import React from 'react';
import { translate } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

function ESIMRulesModal(props) {
    const classes = useStyles();

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            classes={classes.modal}
            aria-labelledby="esim-welcome-modal-title"
            aria-describedby="esim-welcome-modal-description"
        >
            <Fade in={props.open}>
                <div className={classes.paper}>
                    <div className="dashboard-esim-modal">
                        <button type="button" className="dashboard-esim-modal-close" onClick={props.onClose}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.733 1.407L10.593 0.267 6 4.86 1.407 0.267 0.267 1.407 4.86 6 0.267 10.593 1.407 11.733 6 7.14 10.593 11.733 11.733 10.593 7.14 6 11.733 1.407Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h3 className="dashboard-esim-modal-title-rules" id="esim-welcome-modal-title">{props.title}</h3>
                        <p className="dashboard-esim-modal-description-rules" id="esim-welcome-modal-description">
                            {props.content}
                        </p>
                        <button
                            type="button"
                            className="dashboard-esim-modal-close-button"
                            onClick={props.onClose}
                        >
                            {props.t('close')}
                        </button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

export default translate('translation')(ESIMRulesModal);
